import { render, staticRenderFns } from "./AlertButton.vue?vue&type=template&id=044d5dcb&"
import script from "./AlertButton.vue?vue&type=script&lang=js&"
export * from "./AlertButton.vue?vue&type=script&lang=js&"
import style0 from "./AlertButton.vue?vue&type=style&index=0&id=044d5dcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports